import request from './index'

// ===== 考核设置 =====
export function getSettings() {
  return request({ url: '/appraisal/settings', method: 'get' })
}
export function updateSetting(type, data) {
  return request({ url: '/appraisal/settings/' + type, method: 'put', data })
}

// ===== 考核模板 =====
export function getTemplates(params) {
  return request({ url: '/appraisal/templates', method: 'get', params })
}
export function createTemplate(data) {
  return request({ url: '/appraisal/templates', method: 'post', data })
}
export function updateTemplate(id, data) {
  return request({ url: '/appraisal/templates/' + id, method: 'put', data })
}
export function deleteTemplate(id) {
  return request({ url: '/appraisal/templates/' + id, method: 'delete' })
}

// ===== 考核记录（管理端）=====
export function createRecords(data) {
  return request({ url: '/appraisal/records/batch', method: 'post', data })
}
export function getRecords(params) {
  return request({ url: '/appraisal/records', method: 'get', params })
}
export function getRecordDetail(id) {
  return request({ url: '/appraisal/records/' + id, method: 'get' })
}
export function assignAssessor(id, data) {
  return request({ url: `/appraisal/records/${id}/assign`, method: 'post', data })
}
export function confirmRecord(id, data) {
  return request({ url: `/appraisal/records/${id}/confirm`, method: 'post', data })
}
export function rejectRecord(id, data) {
  return request({ url: `/appraisal/records/${id}/reject`, method: 'post', data })
}
export function deleteRecord(id) {
  return request({ url: '/appraisal/records/' + id, method: 'delete' })
}
export function getEmployeeOptions() {
  return request({ url: '/appraisal/employee-options', method: 'get' })
}

// ===== 考核统计（管理端）=====
export function getStats(params) {
  return request({ url: '/appraisal/stats', method: 'get', params })
}
export function getStatsTrend(params) {
  return request({ url: '/appraisal/stats/trend', method: 'get', params })
}

// ===== 员工端 =====
export function isManager() {
  return request({ url: '/appraisal/is-manager', method: 'get' })
}

export function getTeamTodoCount() {
  return request({ url: '/appraisal/todo-count', method: 'get' })
}
export function getMyTeam(params) {
  return request({ url: '/appraisal/my-team', method: 'get', params })
}
export function submitScore(id, data) {
  return request({ url: `/appraisal/records/${id}/score`, method: 'post', data })
}

export function saveScoreDraft(id, data) {
  return request({ url: `/appraisal/records/${id}/draft`, method: 'post', data })
}

export function withdrawScore(id) {
  return request({ url: `/appraisal/records/${id}/withdraw`, method: 'post' })
}
export function getMyAppraisals() {
  return request({ url: '/appraisal/my', method: 'get' })
}
